import React, { useEffect, useState } from "react";
import { Breadcrumb, BreadcrumbItem, Button, Col, Container, Input, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import { translate } from "react-switch-lang";
import styles from "./thematicFolder.module.scss";
import ClickAwayListener from "react-click-away-listener";
import keycloak from "../../security/keycloak-config";
import hasRoles from "../../security/hasRoles";
import AddFolderThematic from "./add-folder-thematic/addFolderThematic";
import { useHttpClient } from "../../security/hooks/axiosProvider";
import { ThematicFolderDto } from "../../models/ThematicFolderDto";
import ThematicFolderCard from "./thematic-folder-card/thematicFolderCard";
import SweetAlert from "sweetalert2";
import { toast } from "react-toastify";
import ThematicFolderList from "./thematic-folder-list/thematicFolderList";
import AddMedia from "./add-media/addMedia";
import Header from "../header/header";
import Taptop from "../template/tap-top";
import { Link } from "react-router-dom";
import { Home as IconHome } from "react-feather";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { useLocation } from "react-router-dom";
import { CategoryDto } from "../../models/categoryDto";
import Footer from "../template/footer";
import ThematicFolderMediaCard from "./thematic-folder-card/thematic-folder-media-card/thematicFolderMediaCard";
import ImageGallery from "react-image-gallery";
import FileViewer from "../template/file-viewer/FileViewer";
import ReactPlayer from "react-player";
import Pagination from "../pagination/pagination";

const ThematicFolder: React.FC<{ t: (key: string) => {} }> = props => {
  toast.configure();
  const httpClient = useHttpClient(false);
  const [viewdropdown, setViewdropdown] = useState(false);
  const [isListDisplayMode, setIsListDisplayMode] = useState<boolean>(true);
  const hasRoleAdmin = hasRoles(["ROLE_MEDIATHEQUE_ADMIN"], keycloak);
  const [openModalAddFolder, setOpenModalAddFolder] = useState<boolean>(false);
  const [openModalAddMedia, setOpenModalAddMedia] = useState<boolean>(false);
  const [isOnCreate, setIsOnCreate] = useState<boolean>(true);
  const [isShowDropZone, setIsShowDropZone] = useState<boolean>(true);
  const [formValidation, setFormValidation] = useState<boolean>(false);
  const [listThematicFolder, setListThematicFolder] = useState<ThematicFolderDto[]>([]);
  const [listFilterThematicFolder, setListFilterThematicFolder] = useState<ThematicFolderDto[]>([]);
  const [editFolderData, setEditFolderData] = useState<any>();
  const [parentId, setParentId] = useState<number>(0);
  const selectedLanguage = useSelector((state: RootState) => state.language.currentLang);
  const [listParent, setListParent] = useState<ThematicFolderDto[]>([]);
  const [category, setCategory] = useState<CategoryDto>(new CategoryDto());
  const [listMedia, setListMedia] = useState<any>([]);
  const [listFilterMedia, setListFilterMedia] = useState<any>([]);
  const location = useLocation();
  const [openModalViewer, setOpenModalViewer] = useState<boolean>(false);
  const [openModalVideo, setOpenModalVideo] = useState<boolean>(false);
  const [openImageViewer, setOpenImageViewer] = useState<boolean>(false);
  const [totalElement, setTotalElement] = useState<number>(0);
  const [, setTotalFolder] = useState<number>(0);
  const [, setTotalMedia] = useState<number>(0);
  const [data, setData] = useState<any>();
  const [pageNumbers, setPageNumbers] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [elementPerPage] = useState(8);

  useEffect(() => {
    httpClient.current?.get("/category/" + location.pathname.split("/")[3]).then(res => {
      setCategory(res.data);
      httpClient.current?.get("/thematic_folder", { params: { parentId: 0, categoryId: res.data.categoryId } }).then(response => {
        setListThematicFolder(response.data);
        setListFilterThematicFolder(response.data);
        httpClient.current?.get("/thematic_folder_media", { params: { parentId: 0 } }).then(respons => {
          setListMedia(respons.data);
          setListFilterMedia(respons.data);
          setTotalElement(response.data.length + respons.data.length);
          setPageNumbers(Math.ceil((response.data.length + respons.data.length) / elementPerPage));
          setTotalFolder(response.data.length);
          setTotalMedia(respons.data.length);
        });
      });
      httpClient.current?.get("/thematic_folder/parent", { params: { parentId: 0, categoryId: res.data.categoryId } }).then(response => {
        setListParent(response.data);
      });
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [httpClient]);

  const viewSelection = () => {
    setViewdropdown(!viewdropdown);
  };

  const handleGetListFolderThematic = id => {
    httpClient.current?.get("/thematic_folder", { params: { parentId: id, categoryId: category.categoryId } }).then(response => {
      setTotalFolder(response.data.length);
      setListThematicFolder(response.data);
      setListFilterThematicFolder(response.data);
      handleGetAllParent(id);
      handleGetMediaByParentId(id, response.data.length);
    });
  };

  const handleClickAddDossier = (isOnCreat: boolean) => {
    setOpenModalAddFolder(!openModalAddFolder);
    setIsOnCreate(isOnCreat);
    if (isOnCreat) {
      setIsShowDropZone(true);
      setFormValidation(false);
    } else {
      setIsShowDropZone(false);
      setFormValidation(true);
    }
  };

  const handleClickAddMedia = (isOnCreat: boolean, addClassList: boolean) => {
    if (addClassList) {
      document.body.classList.add("modal-open");
      setOpenModalAddMedia(!openModalAddMedia);
    } else {
      document.body.classList.remove("modal-open");
      setOpenModalAddMedia(!openModalAddMedia);
    }

    setIsOnCreate(isOnCreat);
    if (isOnCreat) {
      setIsShowDropZone(true);
      setFormValidation(false);
    } else {
      setIsShowDropZone(false);
      setFormValidation(true);
    }
  };

  const handleClickThematicFolder = (id: number) => {
    setParentId(id);
    setCurrentPage(0);
    handleGetListFolderThematic(id);
    // handleGetAllParent(id);
  };

  const handleGetAllParent = (id: number) => {
    httpClient.current?.get("/thematic_folder/parent", { params: { parentId: id, categoryId: category.categoryId } }).then(response => {
      setListParent(response.data);
    });
  };

  const handleUpdateThematicFolder = (data: ThematicFolderDto) => {
    setIsOnCreate(false);
    setIsShowDropZone(false);
    setEditFolderData(data);
    setOpenModalAddFolder(!openModalAddFolder);
  };

  const handleRemoveThematicFolder = (thematicFolderId: number) => {
    SweetAlert.fire({
      title: props.t("message_confirmation_delete_folder"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: String(props.t("button_delete")),
      cancelButtonText: String(props.t("button_cancel")),
      reverseButtons: true,
    }).then(result => {
      if (result.value) {
        httpClient.current?.delete("/thematic_folder/" + thematicFolderId).then(response => {
          toast.success(props.t("message_toastr_delete"), {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 5000,
          });
          handleGetListFolderThematic(parentId);
        });
      }
    });
  };

  const handleGetMediaByParentId = (parentId: number, totalFolder: number) => {
    httpClient.current?.get("/thematic_folder_media", { params: { parentId: parentId } }).then(response => {
      setTotalMedia(response.data.length);
      setListMedia(response.data);
      setListFilterMedia(response.data);
      setTotalElement(response.data.length + totalFolder);
      setPageNumbers(Math.ceil((response.data.length + totalFolder) / elementPerPage));
    });
  };

  const handleClickImage = (data: any) => {
    setData(data);
    if (+data.typeCategory === 0) {
      setOpenModalViewer(!openModalViewer);
    } else if (+data.typeCategory === 1) {
      setOpenModalVideo(!openModalVideo);
    } else {
      setOpenImageViewer(!openImageViewer);
    }
  };

  const handleClickOpenModalViewer = (): void => {
    setOpenModalViewer(!openModalViewer);
  };

  const handleClickOpenModalVideo = (): void => {
    setOpenModalVideo(!openModalVideo);
  };

  const handleClickOpenImageViewer = (): void => {
    setOpenImageViewer(!openImageViewer);
  };

  const removeMediaById = (id: number) => {
    SweetAlert.fire({
      title: props.t("message_confirmation_delete_media"),
      icon: "warning",
      // iconHtml: `<img className="img-50" src=${iconDelete}>`,
      showCancelButton: true,
      confirmButtonText: String(props.t("button_remove")),
      cancelButtonText: String(props.t("button_cancel")),
      reverseButtons: true,
    }).then(result => {
      if (result.value) {
        httpClient.current?.delete("/thematic_folder_media", { params: { thematicFolderMediaId: id } }).then(response => {
          toast.success(props.t("message_toastr_delete"), {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 5000,
          });
          handleGetListFolderThematic(parentId);
        });
      }
    });
  };

  const handleSearch = (value: string) => {
    setListFilterThematicFolder(
      listThematicFolder.filter(
        folder =>
          (selectedLanguage === "en" && folder.titleAnglais.toLowerCase().includes(value.trim().toLowerCase())) ||
          (selectedLanguage === "fr" && folder.titleFrancais.toLowerCase().includes(value.toLowerCase().trim())),
      ),
    );
    setListFilterMedia(
      listMedia.filter(
        media =>
          media?.support?.title.toLowerCase().includes(value.trim().toLowerCase()) ||
          media?.supportVideo?.title.toLowerCase().includes(value.trim().toLowerCase()) ||
          (selectedLanguage === "en" && media?.exposition?.titleEn.toLowerCase().includes(value.trim().toLowerCase())) ||
          (selectedLanguage === "fr" && media?.exposition?.titleFr.toLowerCase().includes(value.trim().toLowerCase())),
      ),
    );
    setTotalElement(
      listMedia.filter(
        media =>
          media?.support?.title.toLowerCase().includes(value.trim().toLowerCase()) ||
          media?.supportVideo?.title.toLowerCase().includes(value.trim().toLowerCase()) ||
          (selectedLanguage === "en" && media?.exposition?.titleEn.toLowerCase().includes(value.trim().toLowerCase())) ||
          (selectedLanguage === "fr" && media?.exposition?.titleFr.toLowerCase().includes(value.trim().toLowerCase())),
      ).length +
        listThematicFolder.filter(
          folder =>
            (selectedLanguage === "en" && folder.titleAnglais.toLowerCase().includes(value.trim().toLowerCase())) ||
            (selectedLanguage === "fr" && folder.titleFrancais.toLowerCase().includes(value.toLowerCase().trim())),
        ).length,
    );
  };

  const paginate = (index: number, e: any) => {
    e.preventDefault();
    setCurrentPage(index);
  };

  return (
    <>
      <Taptop />
      <div className="page-wrapper compact-wrapper" id="pageWrapper">
        <Header></Header>
        <div className={`${styles["plan"]} page-body-wrapper`}>
          <div className={`${styles["agrisud-page-body"]} ${styles["bg"]}  page-body`}>
            <Container fluid>
              <div className="page-title">
                <Row className="p-l-10">
                  <Breadcrumb className="float-left m-t-10 m-b-20">
                    <BreadcrumbItem>
                      <Link to={`/`}>
                        <IconHome />
                      </Link>
                    </BreadcrumbItem>
                    {/* <BreadcrumbItem>
                        <Link to={`${process.env.PUBLIC_URL}/`}>Accueil</Link>
                      </BreadcrumbItem> */}
                    {parentId === 0 ? (
                      <BreadcrumbItem active>{selectedLanguage === "en" ? category?.titleAnglais : category?.titleFrancais}</BreadcrumbItem>
                    ) : (
                      <BreadcrumbItem onClick={() => handleClickThematicFolder(0)} className={styles["breadcrumb-item"]}>
                        {selectedLanguage === "en" ? category?.titleAnglais : category?.titleFrancais}
                      </BreadcrumbItem>
                    )}
                    {listParent
                      .filter(item => item.thematicFolderId !== parentId)
                      .map(item => {
                        return (
                          <BreadcrumbItem onClick={() => handleClickThematicFolder(item.thematicFolderId)} className={styles["breadcrumb-item"]}>
                            {selectedLanguage === "en" ? item?.titleAnglais : item?.titleFrancais}
                          </BreadcrumbItem>
                        );
                      })}
                    {listParent
                      .filter(item => item.thematicFolderId === parentId)
                      .map(item => {
                        return <BreadcrumbItem active>{selectedLanguage === "en" ? item?.titleAnglais : item?.titleFrancais}</BreadcrumbItem>;
                      })}
                  </Breadcrumb>
                </Row>
              </div>
              <div className={styles["section-search"] + " m-b-40"}>
                <div className={styles["section-total-element"]}>
                  <span className={styles["total-element"] + " m-l-5"}>{totalElement} </span>
                  <span className={styles["title-number__document"]}>{parentId === 0 ? props.t("title_folder") : props.t("title_media")}</span>
                </div>
                {window.outerWidth > 600 && (
                  <ClickAwayListener onClickAway={() => setViewdropdown(false)}>
                    <div className={`${styles["translate_wrapper-view"]} ${viewdropdown ? styles["active"] : ""}`}>
                      <div className={styles["current_lang-view"]}>
                        <div className={styles["lang-view"] + " " + styles["label-list-view"]} onClick={() => viewSelection()}>
                          <i className={`fa fa-eye  ${styles["fa-font-size"]} `}></i>
                          {isListDisplayMode ? props.t("button_view_icon") : props.t("button_view_list")}
                        </div>
                      </div>
                      <div className={`${styles["more_lang-view"]} ${viewdropdown ? styles["active"] : ""}`}>
                        <div
                          className={styles["lang-view"]}
                          onClick={() => {
                            viewSelection();
                            setIsListDisplayMode(false);
                          }}
                        >
                          <i className="fa fa-list m-t-5"></i>
                          <span className={styles["lang-txt-view"]}>{props.t("button_view_list")}</span>
                        </div>
                        <div
                          className={styles["lang-view"]}
                          onClick={() => {
                            viewSelection();
                            setIsListDisplayMode(true);
                          }}
                        >
                          <i className="fa fa-th-large m-t-5"></i>
                          <span className={styles["lang-txt-view"]}>{props.t("button_view_icon")}</span>
                        </div>
                      </div>
                    </div>
                  </ClickAwayListener>
                )}
                {parentId === 0 ? (
                  <>
                    <Input
                      onChange={e => {
                        handleSearch(e.target.value);
                      }}
                      className={styles["input-search"]}
                      placeholder={String(props.t("filters.input_placeholder_search"))}
                    ></Input>
                    {window.outerWidth > 854 && <i className={styles["icon-search"] + " fa fa-search"}></i>}

                    {hasRoleAdmin && (
                      <Button onClick={() => handleClickAddDossier(true)} outline color="success" className={styles["add-btn"] + " m-r-20 float-right"}>
                        {props.t("button_add_folder")}
                      </Button>
                    )}
                  </>
                ) : (
                  <>
                    <Input
                      onChange={e => {
                        handleSearch(e.target.value);
                      }}
                      className={styles["input-search-media"]}
                      placeholder="Recherche"
                    ></Input>
                    {window.outerWidth > 854 && <i className={styles["icon-search"] + " fa fa-search"}></i>}

                    {hasRoleAdmin && (
                      <>
                        <Button onClick={() => handleClickAddDossier(true)} outline color="success" className={styles["add-btn"] + " m-r-10 float-right"}>
                          {props.t("button_add_folder")}
                        </Button>
                        <Button onClick={() => handleClickAddMedia(true, true)} outline color="success" className={styles["add-btn"] + " m-l-10 m-r-20 float-right"}>
                          {props.t("button_add_medias")}
                        </Button>
                      </>
                    )}
                  </>
                )}
              </div>
              <Container fluid>
                <Row>
                  <Col className="m-t-30" xl="12">
                    <Row>
                      {/* <div className={styles["categories-container"]}> */}
                      {/* {listFilterThematicFolder.length > 0 ? ( */}
                      {isListDisplayMode ? (
                        listFilterThematicFolder.map((data: ThematicFolderDto, index) => {
                          return (
                            currentPage * elementPerPage <= index &&
                            (currentPage + 1) * elementPerPage > index && (
                              <Col key={data.thematicFolderId} sm={12} md={6} xl={3}>
                                <ThematicFolderCard
                                  data={data}
                                  handleGetListFolderThematic={handleGetListFolderThematic}
                                  handleClickThematicFolder={handleClickThematicFolder}
                                  handleUpdateThematicFolder={handleUpdateThematicFolder}
                                  key={index}
                                  handleRemoveThematicFolder={handleRemoveThematicFolder}
                                />
                              </Col>
                            )
                          );
                        })
                      ) : (
                        <ThematicFolderList
                          currentPage={currentPage}
                          elementPerPage={elementPerPage}
                          paginate={paginate}
                          handleClickCategory={handleClickThematicFolder}
                          handleUpdateThematicFolder={handleUpdateThematicFolder}
                          listFilterThematicFolder={listFilterThematicFolder}
                          handleRemoveThematicFolder={handleRemoveThematicFolder}
                          handleClickThematicFolder={handleClickThematicFolder}
                          handleClickImage={handleClickImage}
                          listMedia={listFilterMedia}
                          removeMediaById={removeMediaById}
                        />
                      )}

                      {isListDisplayMode
                        ? listFilterMedia.map((media, index: number) => {
                            return (
                              currentPage * elementPerPage <= index + listFilterThematicFolder.length &&
                              (currentPage + 1) * elementPerPage > index + listFilterThematicFolder.length && (
                                <Col key={media.thematicFolderMediaId} sm={12} md={6} xl={3}>
                                  <ThematicFolderMediaCard
                                    data={media}
                                    handleGetListFolderThematic={handleGetListFolderThematic}
                                    handleClickThematicFolder={handleClickThematicFolder}
                                    handleUpdateThematicFolder={handleUpdateThematicFolder}
                                    key={index}
                                    handleRemoveThematicFolder={handleRemoveThematicFolder}
                                    handleClickImage={handleClickImage}
                                    removeMediaById={removeMediaById}
                                  />
                                </Col>
                              )
                            );
                          })
                        : ""}
                      {listFilterThematicFolder.length === 0 && listFilterMedia.length === 0 && (
                        <div className={styles["no-data"] + " text-center"}>
                          <span>{props.t("message_no_folder")}</span>
                        </div>
                      )}
                    </Row>
                  </Col>
                  <div className={styles["section-pagination"] + " m-t-10"}>
                    <br />
                    <Pagination pageNumbers={pageNumbers} paginate={paginate} currentPage={currentPage}></Pagination>
                  </div>
                </Row>
              </Container>
            </Container>
          </div>
          <Footer />
        </div>
      </div>
      <Modal isOpen={openModalAddFolder} size="lg">
        <ModalHeader toggle={() => handleClickAddDossier(true)}>{isOnCreate ? props.t("title_add_folder") : props.t("title_update_folder")}</ModalHeader>
        <ModalBody>
          <AddFolderThematic
            isShowDropZone={isShowDropZone}
            setIsShowDropZone={setIsShowDropZone}
            modal={openModalAddFolder}
            isOnCreate={isOnCreate}
            formValidation={formValidation}
            toggle={handleClickAddDossier}
            parentId={parentId}
            handleGetListFolderThematic={handleGetListFolderThematic}
            categoryId={category.categoryId}
            //   setBookmarklist={setBookmarklist}
            //   setListFilterCatgory={setListFilterCatgory}
            editFolderData={editFolderData}
          ></AddFolderThematic>
        </ModalBody>
      </Modal>

      <Modal isOpen={openModalAddMedia} size="xl">
        <ModalHeader toggle={() => handleClickAddMedia(true, false)}>{props.t("title_add_medias")}</ModalHeader>
        <ModalBody className={styles["card-add-media"]}>
          <AddMedia parentId={parentId} toggle={() => handleClickAddMedia(true, false)} handleGetListFolderThematic={handleGetListFolderThematic} />
        </ModalBody>
      </Modal>

      <Modal isOpen={openModalViewer} toggle={() => handleClickOpenModalViewer()} size="xl" className={styles["support-modal"]}>
        <ModalHeader toggle={() => setOpenModalViewer(!openModalViewer)}></ModalHeader>
        <ModalBody>
          <FileViewer src={data?.support?.urlSupport} width={"100%"}  height={(window.innerHeight*0.83)+"px"} />
        </ModalBody>
      </Modal>

      <Modal isOpen={openModalVideo} toggle={() => handleClickOpenModalVideo()} size="xl">
        <ModalHeader toggle={() => setOpenModalVideo(!openModalVideo)}></ModalHeader>
        <ModalBody>
          <ReactPlayer
            url={data?.supportVideo?.link}
            width="100%"
            height="82vh"
            onError={() => {
              toast.error(props.t("message_toastr_inaccessible_video"), {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 5000,
              });
            }}
            playing={data?.supportVideo?.urlSupport ? true : false}
            controls={true}
            light={data?.supportVideo?.urlSupport ? data?.supportVideo?.urlSupport + "/preview" : false}
          />
        </ModalBody>
      </Modal>
      <Modal isOpen={openImageViewer} toggle={() => handleClickOpenImageViewer()} size="lg">
        <ModalHeader toggle={() => setOpenImageViewer(!openImageViewer)}></ModalHeader>
        <ModalBody>
          <ImageGallery
            items={data?.exposition?.listExpositionImage?.map((image: any) => {
              return { original: image.urlImage, thumbnail: image.urlImage };
            })}
            thumbnailPosition={"bottom"}
            showBullets={true}
            showPlayButton={true}
          />
        </ModalBody>
      </Modal>
    </>
  );
};

export default translate(ThematicFolder);
